import tafFetch, { checkRes, TReqParams } from "./_tafFetch";
import { HUYA } from "@/assets/jce/LuckyBagServant";
import { HUYA as PCDownloaderServant } from "@/assets/jce/PCDownloaderServant";

// 模版例子
export async function getLuckyBagPanel() {
  const req = new HUYA.LuckyBagCommReq();
  const res = await tafFetch({
    data: req,
    funcName: "getLuckyBagPanel",
    moduleName: "wupui",
    ReqClass: HUYA.LuckyBagCommReq,
    RspClass: HUYA.LuckyBagPanel,
  });
  checkRes(res);
  return res;
}

/**
 * int getPCDownloaderbyHttpRequest(GetPCDownloaderbyHttpRequestReq tReq, out GetPCDownloaderbyHttpRequestRsp tRsp);
 */
export async function getPCDownloaderbyHttpRequest(
  params?: TReqParams<PCDownloaderServant.GetPCDownloaderbyHttpRequestReq>,
) {
  const res = await tafFetch({
    data: params || {},
    funcName: "getPCDownloaderbyHttpRequest",
    moduleName: "wupui",
    ReqClass: PCDownloaderServant.GetPCDownloaderbyHttpRequestReq,
    RspClass: PCDownloaderServant.GetPCDownloaderbyHttpRequestRsp,
  });
  return res;
}
